export enum RtbfRefStatus {
    Requested = 1,
    AwaitingApproval,
    PendingProcessing,
    Processed,
    Declined,
}

export interface RtbfStatus {
    rtbfStatusId?: number;
    requestingUserId: number;
    requestedUserId: number;
    statusId: RtbfRefStatus;
    dateRequested: Date;
    dateApproved?: Date;
    timeUntilProcessing?: Date;
    reason: string;
}